
export function capitalFirst(selectedSide) {return selectedSide && (selectedSide.charAt(0).toUpperCase() + selectedSide.slice(1)); }

export function shortAddress(account) {
    if(!account || account.length < 6) {
        return account;
    }
    return account.slice(0,6) + "..." + account.slice(account.length - 4, account.length);
}

export function formatDate(date) {
    return date.getDate()+ "." + date.getMonth() + "." + date.getFullYear();
}

export function formatDateTime(date) {
    return formatDate(date) + ", " + formatTime(date);
}

export function formatTime(date) {
    return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
}

export function formatTimespan(time) {
    const oneHour = 1000*60*60;
    const oneMinute = 1000*60;
    const oneSecond = 1000;
    //console.log("formatTimespan", time);
    const hours = parseInt(time/oneHour);
    const minutes = parseInt(time%oneHour/oneMinute);
    const secs = parseInt(time%oneMinute/oneSecond);
    return hours + ":" + minutes + ":" + secs;
}


